import { render, staticRenderFns } from "./AwardBannerModal.vue?vue&type=template&id=2dadd88f&scoped=true&"
import script from "./AwardBannerModal.vue?vue&type=script&lang=js&"
export * from "./AwardBannerModal.vue?vue&type=script&lang=js&"
import style0 from "./AwardBannerModal.vue?vue&type=style&index=0&id=2dadd88f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dadd88f",
  null
  
)

export default component.exports